import React from 'react';
import { IntegrationField, JiraIssueType } from 'api/integrations';
import { Input } from 'components/atoms/input';
import { Select } from 'components/atoms/select';
import {
  filterableFieldType,
  IntegrationFieldType,
} from 'components/molecules/integrations-commons';

type GenerateDefaultTableCells = {
  field: IntegrationField;
  onIssueTypeChange: (valObject: any) => void;
  issueTypes?: JiraIssueType[];
  loading?: boolean;
};

export const generateDefaultTableCells = ({
  field,
  onIssueTypeChange,
  issueTypes,
  loading,
}: GenerateDefaultTableCells): JSX.Element => {
  switch (filterableFieldType(field)) {
    case IntegrationFieldType.Summary: {
      return <Input disabled value="Task Name" />;
    }

    case IntegrationFieldType.Description: {
      return <Input disabled value="Task Description" />;
    }

    case IntegrationFieldType.IssueType: {
      const transformOptions = issueTypes?.map((option) => ({
        value: option.id,
        label: option.name,
        integrationFieldId: field.integrationFieldId,
      }));

      const selected = transformOptions?.find(
        (option) => option.value === field?.metaData?.default,
      );

      return (
        <Select
          value={selected}
          options={transformOptions}
          onChange={onIssueTypeChange}
          isLoading={loading}
          isDisabled={loading}
        />
      );
    }

    default: {
      return <></>;
    }
  }
};
